import React, { useContext } from 'react'
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context'
import { GeneralStudentStyleButton } from '../avalia/style';

const ReportProficiencyScalePageButtons = () => {
  const { filtrosRelatorios, setStateFilters } = useContext(FilterRelatorioContext)

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: '1rem',
        width: '100%',
      }}
    >
      <button
        style={{
          color: 'white',
          width: '15%',
          backgroundColor: '#9c9c9c',
          border: 'none',
          fontSize: '1rem',
          fontWeight: '600',
          textAlign: 'center',
          borderRadius: '15px',
          boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
          padding: '4px 16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onClick={() => {
          handleScrollToTop();
          setStateFilters({ fecthComparativo: false, fecthRelatorioGeral: false, fecthRelatorioHabilidade: false, fecth: true })
        }}
      >
        Voltar
      </button>
      <GeneralStudentStyleButton>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end'
          }}
        >
          {!filtrosRelatorios.fecthComparativo && (
            <button
              className="button-secondary"
              style={{
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                borderRadius: '20px',
                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                padding: '4px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '1rem'
              }}
              onClick={() => {
                handleScrollToTop();
                setStateFilters({ fecthComparativo: true, fecthRelatorioGeral: false, fecthRelatorioHabilidade: false, fecth: false })
              }}
            >
              Comparativo entre turmas
            </button>
          )}
          {!filtrosRelatorios.fecthRelatorioHabilidade && (
            <button
              className="button-primary"
              style={{
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                borderRadius: '20px',
                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                padding: '4px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '1rem'
              }}
              onClick={() => {
                handleScrollToTop();
                setStateFilters({ fecthComparativo: false, fecthRelatorioGeral: false, fecthRelatorioHabilidade: true, fecth: false })
              }}
            >
              Relatório de Habilidades
            </button>
          )}
          {!filtrosRelatorios.fecthRelatorioGeral && (
            <button
              className="button-primary"
              style={{
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                borderRadius: '20px',
                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                padding: '4px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '1rem'
              }}
              onClick={() => {
                handleScrollToTop();
                setStateFilters({ fecthComparativo: false, fecthRelatorioGeral: true, fecthRelatorioHabilidade: false, fecth: false })
              }}
            >
              Relatório de Proficiência
            </button>
          )}
        </div>
      </GeneralStudentStyleButton>
    </div>
  )
}

export default ReportProficiencyScalePageButtons;